import { render, staticRenderFns } from "./CSideDriverAccountsDetail.vue?vue&type=template&id=f436c79c&scoped=true&"
import script from "./CSideDriverAccountsDetail.vue?vue&type=script&lang=js&"
export * from "./CSideDriverAccountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CSideDriverAccountsDetail.vue?vue&type=style&index=0&id=f436c79c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f436c79c",
  null
  
)

export default component.exports